<form class="enquiries-form" [formGroup]="form">
  <div class="enquiries-title" i18n="@@enquiries.title" data-translate="enquiries.title">Title</div>
  <ng-container *ngIf="!submitted; else submittedTemplate">
    <div class="enquiries-desc text" i18n="@@enquiries.description" data-translate="enquiries.description">
      Description
    </div>
    <div class="enquiries-input-group">
      <label
        for="name-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.name"
        data-translate="enquiries.filters.name"
        >Name</label
      >
      <input id="name-input" type="text" [class]="" pInputText formControlName="name" />
      <ng-container *ngIf="submitIntent">
        <small
          *ngIf="form.get('name').errors"
          class="p-error block"
          i18n="@@public.error.provideName"
          data-translate="public.error.provideName"
          >Provide name</small
        >
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label
        for="surname-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.surname"
        data-translate="enquiries.filters.surname"
        >Surname</label
      >
      <input id="surname-input" type="text" [class]="" pInputText formControlName="surname" />
      <ng-container *ngIf="submitIntent">
        <small
          *ngIf="form.get('surname').errors"
          class="p-error block"
          i18n="@@public.error.provideSurname"
          data-translate="public.error.provideSurname"
          >Provide surname</small
        >
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label
        for="company-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.company"
        data-translate="enquiries.filters.company"
        >Company</label
      >
      <input id="company-input" type="text" pInputText formControlName="company" />
      <ng-container *ngIf="submitIntent">
        <small
          *ngIf="form.get('company').errors"
          class="p-error block"
          i18n="@@public.error.provideCompany"
          data-translate="public.error.provideCompany"
          >Provide company</small
        >
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label
        for="companyRole-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.companyRole"
        data-translate="enquiries.filters.companyRole"
        >Company role</label
      >
      <input id="companyRole-input" type="text" pInputText formControlName="companyRole" />
    </div>
    <div class="enquiries-input-group">
      <label
        for="email-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.email"
        data-translate="enquiries.filters.email"
        >Email</label
      >
      <input id="email-input" type="email" pInputText formControlName="email" />
      <ng-container *ngIf="submitIntent">
        <small
          *ngIf="form.get('email').errors"
          class="p-error block"
          i18n="@@public.error.provideEmail"
          data-translate="public.error.provideEmail"
          >Provide email</small
        >
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label
        for="country-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.country"
        data-translate="enquiries.filters.country"
        >Country</label
      >
      <p-multiSelect
        id="country-input"
        [virtualScroll]="true"
        [itemSize]="30"
        [options]="countryList"
        optionLabel="name"
        [showToggleAll]="false"
        i18n-defaultLabel="@@public.filters.country.select"
        defaultLabel="Select country"
        class="fix"
        formControlName="country"
      >
      </p-multiSelect>
      <!-- Movie no available for this country at the moment message -->

      <ng-container *ngIf="submitIntent">
        <small
          *ngIf="form.get('country').errors"
          class="p-error block"
          i18n="@@public.error.provideCountry"
          data-translate="public.error.provideCountry"
          >Provide country</small
        >
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label
        for="comments-input"
        class="enquiry-label subtitle"
        i18n="@@enquiries.filters.comments"
        data-translate="enquiries.filters.comments"
        >Comments</label
      >
      <textarea
        class="text"
        id="comments-input"
        [rows]="5"
        [cols]="30"
        pInputTextarea
        autoResize="autoResize"
        formControlName="comments"
      ></textarea>
    </div>
    <button class="button enquiries-submit" (click)="onSubmit()">
      <ng-container *ngIf="!processingSubmition; else loading">
        <span i18n="@@competition.form.submit" data-translate="competition.form.submit">Submit</span>
      </ng-container>
    </button>
  </ng-container>
</form>

<!-- TEMPLATES -->

<ng-template #loading>
  <ush-loading-indicator fontSize="30px" height="auto"></ush-loading-indicator>
</ng-template>

<ng-template #submittedTemplate>
  <div class="submitted-msg">Thanks for submitting your query, we will back to you soon.</div>
</ng-template>
